export const RUOLI = ['partecipante', 'relatore', 'regia', 'admin'] as const;
export type Ruolo = (typeof RUOLI)[number];

export const STATI_UTENTE = ['in_verifica', 'attivo', 'sospeso'] as const;
export type StatoUtente = (typeof STATI_UTENTE)[number];

export const SCOPI_OTP = ['verifica_email', 'nuovo_dispositivo', 'reset', 'completa_iscrizione'] as const;
export type ScopoOtp = (typeof SCOPI_OTP)[number];
